<template>
  <body class="LedBody">
    <div class="ledContainter" id="LEDContainter">
      <table class="ledTb">
        <tbody id="ledTable"></tbody>
      </table>
    </div>
  </body>
</template>

<script>
//引入hrEmployee.js的所有export的对象,并起别名为api,通过api.***访问成员
import { getSysStationListPage } from "../../api/station";
import originJSONP from "jsonp";
export default {
  data() {
    return {
      orgId: "", //当前登录用户的OrgId
      SysStation: [], //搅拌站信息
      ledUrl: "",
      ledAuto: null,
      outtime: 5000, //5秒执行一次刷新页面
      ledId: 1,
      ledSocket: {}, //Socket对象
    };
  },
  computed: {},
  methods: {
    //获取生产线列表
    getSysStation() {
      if (localStorage.currentOrg) {
        this.orgId = JSON.parse(localStorage.currentOrg).Id;
      } else if (localStorage.sysOrgs) {
        this.orgId = JSON.parse(localStorage.sysOrgs)[0].Id;
      }
      let para = {
        key: this.orgId,
      };
      //获取搅拌站信息
      getSysStationListPage(para).then((res) => {
        this.SysStation = res.data.response.data;
        if (
          this.SysStation &&
          this.SysStation.length > 0 &&
          this.SysStation[0].LedsServiceAddress &&
          this.SysStation[0].LedsServiceAddress != ""
        ) {
          this.ledUrl = this.SysStation[0].LedsServiceAddress;
          this.getLedHtml();
        }
      });
    },
    getLedHtml() {
      if (this.ledUrl.indexOf("ws://") != -1) {
        this.ledSocketInit();
        return;
      }
      if (this.ledAuto) {
        clearTimeout(this.ledAuto);
      }
      try {
        originJSONP(
          this.ledUrl + "/LedSvc/LedContent?ledId=" + this.ledId,
          null,
          (err, data) => {
            if (data) {
              document.getElementById("ledTable").innerHTML = data;
            }

            this.ledAuto = setTimeout(() => {
              this.getLedHtml();
            }, this.outtime);
          }
        );
      } catch {
        this.ledAuto = setTimeout(() => {
          this.getLedHtml();
        }, this.outtime);
      }
    },
    ledSocketInit() {
      let that = this;
      //链接服务端
      this.ledSocket = new WebSocket(this.ledUrl+'/LED'+this.ledId);
      //配置客户端连接成功的回调方法
      this.ledSocket.onopen = function (event) {
        console.log("ledSocketopen...");
      };
      //配置客户端处理消息的回调方法
      this.ledSocket.onmessage = function (event) {
        if (that && !that._isDestroyed) {
          document.getElementById("ledTable").innerHTML= event.data;
        } else {
          that.ledSocket.close();
        }
      };
      this.ledSocket.onerror = function (event) {
        console.log("ledSocketerror...");
        //  initVideo();
      };
      this.ledSocket.onclose = function (event) {
        console.log("ledSocketclose...");
        if (that && !that._isDestroyed) {
          that.ledSocketInit();
        }
      };
    },
  },
  mounted() {
    this.getSysStation();
  },
};
</script>

<style lang="less">
.LedBody {
  background: #000;
  font-size: 14px;

  padding: 0;
  margin: 0;
  padding-right: 3px;
}

.LedBody table,
.LedBody td,
.LedBody tr,
.LedBody th {
  font-size: 14px;
}

.LedBody th {
  font-weight: bold;
  text-align: center;
}

.LedBody table {
  margin: 0 auto;
}

.ledContainter {
  width: 100%;
  height: 100%;
}

.LedBody .ledTb {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  border-collapse: collapse;
}

.LedBody .ledTb td {
  border: 5px solid #ff0000;
  color: #ff0000;
  font-weight: bold;
  font-size: 60px;
  padding: 10px;
  text-align: center;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
